module.exports = __webpack_public_path__ + "img/logo.dddf8fe3.png";